// Logika Status Bayar pelanggan (dipakai komponen bersama EbillingCustomers: Menu Pelanggan,
// Menu Tagihan, Laporan Baru/Beta). Modul murni (tanpa React) agar dapat di-unit-test dengan tanggal terkontrol.
const ID_MONTHS = { januari: 1, februari: 2, maret: 3, april: 4, mei: 5, juni: 6, juli: 7, agustus: 8, september: 9, oktober: 10, november: 11, desember: 12 };

const num = (v) => { const n = parseInt(String(v ?? "").replace(/[^\d-]/g, ""), 10); return Number.isFinite(n) ? n : 0; };
const isoDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Bangun tanggal jatuh tempo penuh (YYYY-MM-DD) untuk perbandingan yang benar.
// Jika sumber hanya angka hari ("07"/"13"/"30"), gabungkan dengan periode tagihan
// ("Oktober 2026" atau "2026-10"). Data tidak cukup -> null (JANGAN mengarang tanggal).
// CATATAN: tgl_jatuh_tempo = jatuh tempo PEMBAYARAN; tanggal pemblokiran/isolir tidak dipakai.
export function dueDateOf(raw) {
  const v = String(raw?.tgl_jatuh_tempo || "").trim();
  if (!v) return null;
  if (/^\d{4}-\d{1,2}-\d{1,2}/.test(v)) return v.slice(0, 10);
  const day = parseInt(v, 10);
  if (!Number.isFinite(day) || day < 1 || day > 31) return null;
  const per = String(raw?.periode_belum_lunas || raw?.periode || "").toLowerCase();
  const iso = per.match(/(\d{4})-(\d{1,2})/);
  const named = per.match(/([a-z]+)\s+(\d{4})/);
  let y, m;
  if (iso) { y = +iso[1]; m = +iso[2]; } else if (named && ID_MONTHS[named[1]]) { y = +named[2]; m = ID_MONTHS[named[1]]; } else return null;
  return `${y}-${String(m).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function paymentStatus(billing, custRaw, today = new Date()) {
  const todayStr = isoDay(today);
  if (!billing) {
    // Pelanggan tanpa tagihan belum lunas -> sudah bayar. Varian "menunggu jatuh tempo"
    // bila tanggal jatuh tempo (lengkap atau angka hari bulan berjalan) belum tiba.
    const v = String(custRaw?.tgl_jatuh_tempo || "").trim();
    let waiting = false;
    if (/^\d{4}-\d{1,2}-\d{1,2}/.test(v)) waiting = v.slice(0, 10) >= todayStr;
    else { const day = parseInt(v, 10); if (Number.isFinite(day) && day >= 1 && day <= 31) waiting = day >= today.getDate(); }
    return waiting
      ? { text: "SUDAH BAYAR — LAYANAN MENUNGGU JATUH TEMPO", color: "#166534", bg: "#dcfce7" }
      : { text: "SUDAH BAYAR", color: "#166534", bg: "#dcfce7" };
  }
  const raw = billing.raw || {};
  const nTunggak = num(raw.jumlah_periode_belum_lunas) || 1;
  if (nTunggak > 1) return { text: `TUNGGAKAN ${nTunggak} PERIODE`, color: "#b91c1c", bg: "#fee2e2" };
  const due = dueDateOf(raw);
  if (!due) return { text: "BELUM LUNAS", color: "#92400e", bg: "#fef3c7" }; // jatuh tempo tak dapat ditentukan — tampil aman
  if (due < todayStr) return { text: "TUNGGAKAN", color: "#b91c1c", bg: "#fee2e2" };
  return { text: "MENDEKATI JATUH TEMPO", color: "#92400e", bg: "#fef3c7" };
}
